import {put, select, takeLatest} from "redux-saga/effects";
import {getType} from "typesafe-actions";
import {addLives} from "../actions";
import {IApplicationState} from "../../index";
import {delay} from "redux-saga";
import {gameInit} from "../../common/actions";
import playSound from "../../../shared/sounds/playSound";

export default function* watchAddLives() {
    yield takeLatest([getType(gameInit), getType(addLives)], function* () {
        const {lives, maxLives, restoreLivesInterval} = yield select(({ player, settings }: IApplicationState) => ({
            lives: player.lives,
            maxLives: settings.gameBalance.maxLives,
            restoreLivesInterval: settings.gameBalance.restoreLivesInterval
        }));

        if (lives < maxLives) {
            yield delay(restoreLivesInterval);

            playSound("life-gained", 0.2);
            yield put(addLives(1, "life_gain_timer_elapsed"));
        }
    });
}